import { motion } from "framer-motion";
import SeedField from "@/components/SeedField";
import EnquiryForm from "@/components/EnquiryForm";
import { SEEDKEEPERS_URL } from "@/lib/api";
import { MEDIA } from "@/lib/media";
import { ArrowUpRight } from "lucide-react";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="relative min-h-screen text-cream">
      <img src={MEDIA.sunrise} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-rainforest/85 via-charcoal/85 to-charcoal/95" />
      <SeedField count={12} />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 pt-40 pb-28 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
        <div className="lg:pt-8">
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="overline text-ochre mb-6">Contact</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.1 }} className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.06]">
            Find the right place to begin.
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="mt-8 text-cream/80 text-lg font-light max-w-lg leading-relaxed">
            Whether you're an individual building skills or an organisation strengthening a team,
            tell us where you're at and what you'd like to establish or improve. We'll be in touch to
            discuss the right next step.
          </motion.p>
          <a href={SEEDKEEPERS_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-seedkeepers" className="group inline-flex items-center gap-2 mt-10 text-cream/70 hover:text-cream text-sm transition-colors">
            Learn more about SeedKeepers <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </div>

        <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.25 }}>
          <EnquiryForm formType="contact" theme="dark" title="Talk with SeedKeepers" cta="Send enquiry" />
        </motion.div>
      </div>
    </div>
  );
}
